import * as React from 'react';
import { once } from '../utils/functions.js';

var EMPTY_FINGERPRINT = Promise.resolve("");
/**
 * Default no-op context value
 *
 * It is used as fallback when no provider (e.g. in NodeJS runtime or when SEON
 * is disabled) is given and lets hooks to continue function properly.
 *
 * @const
 *
 * @access private
 */

var DEFAULT_CONTEXT_VALUE = {
  activate: once(function activate() {
    /* istanbul ignore next: hard to test due to `once` */
    if (process.browser) {
      // eslint-disable-next-line no-console
      console.warn("SEON is either disabled or its provider is missing");
    }
  }),

  resolveFingerprint() {
    return EMPTY_FINGERPRINT;
  }

};
/**
 * React Context for SEON
 *
 * @type {React.Context}
 *
 * @access private
 */

var SeonContext = /*#__PURE__*/React.createContext(DEFAULT_CONTEXT_VALUE);

export { SeonContext };
